export class ProductsLanguages {
    public static panel: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "lb", "da"];
    public static blog: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "lb", "da"];
    public static helpCenter: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "lb", "da"];
    public static livechat: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "lb", "da"];
    public static website: string[] = ["fr", "en", "es", "it", "pt", "nl", "de", "lb", "da"];
}
